import { render, staticRenderFns } from "./RUReadTableView.vue?vue&type=template&id=39361dde"
import script from "./RUReadTableView.vue?vue&type=script&lang=js"
export * from "./RUReadTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports